import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IVodafoneServices } from '../models/response/getAuthorizedServicePointsListResponseModel'

export class GetVodafoneServicesApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'authorizedServiceMain/listAllVodafone',
      requesterInfo,
    })
  }

  public async GetVodafoneServicesList(): Promise<IVodafoneServices[]> {
    return await this.getAsync<IVodafoneServices[]>()
  }
}
